'use client'

import { useEffect } from 'react'
import { hydrateThemeFromStorage } from '@/stores/theme-store'

export function ThemeInit() {
  useEffect(() => {
    hydrateThemeFromStorage()
  }, [])

  return null
}
